import module from 'fan/proyecto/module.js'
import template from './template.html'
import './style.scss'

export class FanProyectoEsquemasEsquemaComisionistasItemComponent {
  data
  color
  onChange
  onDelete
  tiposComisionista = [
    {id: 1, descripcion: 'SA'},
    {id: 2, descripcion: 'Operadora'},
    {id: 3, descripcion: 'Otro'},
  ]
}

module.component('fanProyectoEsquemasEsquemaComisionistasItem', {
  controller: FanProyectoEsquemasEsquemaComisionistasItemComponent,
  template,
  bindings: {
    data: '<',
    color: '<',
    onChange: '&',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/esquemas/esquema/comisionistas/item/component.js